
import React, { useState, useEffect } from "react";
import moment from "moment";
import format from "number-formatter";
import classes from "./transactionStatus.module.css";
import { config } from "constants/config";
import api from "appRedux/api";

function TransactionStatus({ data }) {
  const { transactionId } = data;
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    // const fetchTransactionData = async () => {
    //   setIsLoading(true);
    //   setError(null);
    //   try {
    //     const url = `${config.tokenUrl}/report/operator/whitelist/transactions/${transactionId}`;
    //     const response = await fetch(url, {
    //       method: "GET",
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //     });

    //     if (!response.ok) {
    //       throw new Error(`Failed to fetch transaction: ${response.statusText}`);
    //     }

    //     const result = await response.json();
    //     setApiData(result?.data || null);
    //   } catch (err) {
    //     console.error("Fetch error:", err);
    //     setError("Unable to load transaction details. Please try again later.");
    //   } finally {
    //     setIsLoading(false);
    //   }
    // };

    const fetchTransactionData = async () => {
      setIsLoading(true);
      setError(null);
    
      try {
        const response = await api.get(
          `/report/operator/whitelist/transactions/${transactionId}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
          config.tokenUrl // secure baseURL
        );
    
        const result = response?.data;
        setApiData(result?.data || null);
      } catch (err) {
        console.error("Fetch error:", err);
        setError("Unable to load transaction details. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };
    fetchTransactionData();

  }, [transactionId]);

  if (isLoading) {
    return (
      <div className={classes.statusInner}>
        <div className={classes.loadingState}>
          <p>Loading transaction details...</p>
          <div className={classes.spinner}></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={classes.statusInner}>
        <p className={classes.error}>{error}</p>
      </div>
    );
  }

  if (!apiData) return null;

  const {
    transactionDate,
    reference,
    amount,
    tokenType,
    tokenCategory,
    operatorName,
    customerName,
    phoneNumber,
    email,
    route,
    departureTime,
    paymentMethod,
    channel,
    passengers = [],
    seatNumber
  } = apiData;

  const renderDetail = (label, value) => (
    value ? (
      <div className={classes.statusInnerDetail}>
        <p>{label}:</p>
        <p>{value}</p>
      </div>
    ) : null
  );

  return (
    <div className={classes.statusInner}>
      <h3>Transaction Details</h3>
      {renderDetail("Transaction Date", moment(transactionDate).format("lll"))}
      {renderDetail("Reference", reference)}
      {renderDetail("Amount", `₦${format("#,##0.00", amount)}`)}
      {renderDetail("Ticket Type", tokenType)}
      {renderDetail("Ticket Category", tokenCategory)}
      {renderDetail("Operator Name", operatorName)}
      {renderDetail("Customer Name", customerName)}
      {renderDetail("Phone Number", phoneNumber)}
      {renderDetail("Email", email)}
      {renderDetail("Route", route)}
      {renderDetail("Departure Time", departureTime)}
      {renderDetail("Payment Method", paymentMethod)}
      {renderDetail("Channel", channel === "WHITELABEL" ? "WEB" : channel )}

      {passengers.length > 0 && (
        <div className={classes.passengerSection}>
          <h5 >Passenger Details</h5>
          {passengers.map((p, idx) => (
            <div key={idx} className={classes.passengerCard}>
              <h6 style={{marginTop:"15px"}}>Passenger {idx + 1}</h6>
              {renderDetail("Name", p.passengerName)}
              {renderDetail("Phone Number", p.passengerPhoneNumber)}
              {renderDetail("Gender", p.passengerGender)}
              {renderDetail("Next of Kin", p.passengerNextOfKinName)}
              {renderDetail("Ticket ID", p.token)}
              {renderDetail("Seat Number", p.seatNumber)}

            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default TransactionStatus;

